import React from "react";

import Input from "../Common/Input/Input";
import Back from '../Common/Back/Back';
import { checkInputValidity } from "./../../Utility/utility";
import { SalesContext } from '../../Context/SalesContext';
import "./FinalizeOrder.css";
import { submitLead } from '../../Services/Services';
import SubmitLeadRequestError from "./../Common/SubmitLeadRequestError/SubmitLeadRequestError";
// import { tagOnFinalizeOrderErrorPage, tagOnFinalizeOrder, tagOnFinalizeOrderError } from "./../../Tagging/SalesTagging";

class FinalizeOrder extends React.Component {
	static contextType = SalesContext;

	state = {
		formComponents: {
			firstName: {
				name: "*First Name",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid first name",
					maxLength: 50,
					minLength: 2
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			lastName: {
				name: "*Last name",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid last name",
					maxLength: 50,
					minLength: 2
				},
				config: {
					required: true
				},
				isValid: false,
				isTouched: false
			},
			email: {
				name: "*Email",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid email",
					type: "email"
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			contactNumber: {
				name: "*Contact number",
				type: "input",
				value: "",
				validations: {
					required: true,
					isPhoneNumber: true,
					invalidMessage: "Please enter a valid contact number"
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			idNumber: {
				name: "*ID number",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid 13-digit SA ID number",
					isSAIdNumber: true,
					minLength: 13,
					maxLength: 13
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			},
			passportNumber: {
				name: "*Passport number",
				type: "input",
				value: "",
				validations: {
					required: true,
					invalidMessage: "Please enter a valid Passport number",
					maxLength: 50
				},
				config: {
					type: "text",
					required: true
				},
				isValid: false,
				isTouched: false
			}
		},
		isFormValid: false,
		selectedIdTab: "idNumber",
		formSubmitAttempt: 0,
		hasError: false
	}

	componentDidMount() {
		// tagOnFinalizeOrder();
	}

	formComponentChangeHandler = (event, inputIdentifier) => {
		const formCompsCopy = { ...this.state.formComponents };
		const changedComponent = { ...formCompsCopy[inputIdentifier] };
		changedComponent.value = event.target.value;
		changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
		changedComponent.isTouched = true;

		let tempObj = {};
		tempObj[inputIdentifier] = changedComponent.value;
		this.context.setUserDetails({ key: inputIdentifier, value: changedComponent.value });

		const newFormComps = { ...formCompsCopy, [inputIdentifier]: changedComponent }
		this.setState({ formComponents: newFormComps, isFormValid: this.checkFormValidity(newFormComps) });
	}

	checkFormValidity = (form, selectedIdTab = this.state.selectedIdTab) => form.contactNumber.isValid && form.email.isValid && form.firstName.isValid && form.lastName.isValid && form[selectedIdTab].isValid;

	tabSwitchClick = option => {
		this.setState({ selectedIdTab: option, isFormValid: this.checkFormValidity(this.state.formComponents, option) });
	}

	onSubmit = event => {
		event.preventDefault();
		// Call Lead submission API
		this.submitLeadRequest();
	}

	submitLeadRequest = () => {
		this.context.setShowSpinner(true);
		submitLead(this.context).then(res => {
			this.context.setUserDetails({ key: 'referenceNo', value: res.result.referenceNumber });
			this.props.history.push('/cloud/fibre/sales/success');
			this.context.setShowSpinner(false);
		}).catch(error => {
			if (this.state.formSubmitAttempt <= 4) {
				this.setState(prevState => {
					return {
						hasError: true,
						formSubmitAttempt: prevState.formSubmitAttempt + 1
					}
				})
			} else {
				this.resetError();
				// tagOnFinalizeOrderErrorPage();
				this.props.history.push('/cloud/fibre/sales/error');
			}
			this.context.setShowSpinner(false)
		})
	}

	resetError = () => {
		this.setState({
			hasError: false,
			formSubmitAttempt: 0
		});
	}

	errorResubmitClickHandler = () => {
		// tagOnFinalizeOrderError();
		this.setState(prevState => {
			return {
				hasError: false,
				formSubmitAttempt: prevState.formSubmitAttempt + 1
			}
		});
		// this.submitLeadRequest();
	}

	render() {
		const selectedIdTabStyle = { width: "110%", background: "#565656", color: "white" };
		return <div>
			<div className="finalize-order-container">
				{this.state.hasError ? <SubmitLeadRequestError reSubmit={this.errorResubmitClickHandler} close={this.resetError} /> : null}
				<h1>Let us call you to finalise your order</h1>
				<p>Complete details below and one of our experts will be in touch within 24hrs to finalise your order.</p>
				<div className="finalize-order-form-container">
					<form onSubmit={this.onSubmit}>
						<div className="finalize-order-form-input-row">
							<div><Input inputIdentifier="firstName" changed={this.formComponentChangeHandler} {...this.state.formComponents.firstName} /></div>
							<div><Input inputIdentifier="lastName" changed={this.formComponentChangeHandler} {...this.state.formComponents.lastName} /></div>
						</div>
						<div className="finalize-order-form-input-row">
							<div><Input inputIdentifier="email" changed={this.formComponentChangeHandler} {...this.state.formComponents.email} /></div>
							<div><Input inputIdentifier="contactNumber" changed={this.formComponentChangeHandler} {...this.state.formComponents.contactNumber} /></div>
						</div>
						<div className="finalize-order-form-tab-switcher">
							<span onClick={() => this.tabSwitchClick("idNumber")} style={this.state.selectedIdTab === "idNumber" ? selectedIdTabStyle : null}>ID number</span>
							<span onClick={() => this.tabSwitchClick("passportNumber")} style={this.state.selectedIdTab === "passportNumber" ? selectedIdTabStyle : null}>Passport number</span>
						</div>
						<div className="finalize-order-form-input-row">
							<div>
								{this.state.selectedIdTab === "idNumber" ?
									<Input inputIdentifier="idNumber" changed={this.formComponentChangeHandler} {...this.state.formComponents.idNumber} /> :
									<Input inputIdentifier="passportNumber" changed={this.formComponentChangeHandler} {...this.state.formComponents.passportNumber} />
								}
								<label className="finalize-order-form-id-label">We need this to verify your information</label>
							</div>
							<div></div>
						</div>
						<div style={{ width: "100%", textAlign: "center" }}><button type="submit" disabled={!this.state.isFormValid} className="submit-order-red-button">SUBMIT ORDER</button></div>
					</form>
				</div>
			</div >
			<div>
				<Back />
			</div>
		</div>
	}
}

export default FinalizeOrder;